import { useDataSubmit, useDataValue } from 'Simple/Data.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'

export function useOnClick(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)

  let submit = useDataSubmit({
    context: 'tab',
    viewPath: props.viewPath,
  })

  let stage = useDataValue({
    context: 'stage',
    viewPath: props.viewPath,
  })

  let task_id = useDataValue({
    context: 'tab',
    path: 'selected.task_overlay.task_id',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({
      type: 'set_task_stage',
      task_id,
      stage_id: stage.id,
    })

    setFlowTo(normalizePath(props.viewPath, '../../../../No'))
  }
}
